import React from 'react';
export const Header = () => {
  return <header className="w-full bg-blue-600 py-2 px-4 text-white" data-id="element-128">
      <div className="max-w-5xl mx-auto flex justify-between items-center" data-id="element-129">
        <div className="font-bold text-lg" data-id="element-130">Nevara Québec</div>
        <div className="text-sm" data-id="element-131">
          <span className="mr-3" data-id="element-132">Support en français</span>
          
        </div>
      </div>
    </header>;
};